import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'

import VueMask from 'v-mask'
import VueRouter from 'vue-router'
import vco from "v-click-outside"
import router from './router/index'

import NProgress from 'vue-nprogress'
import Snotify, { SnotifyPosition } from 'vue-snotify'
import '@/design/snotify-style.css'
import axios from 'axios'
import VueAxios from 'vue-axios'
import vSelect from "vue-select";

import "@/design/index.scss";
import VueSweetalert2 from 'vue-sweetalert2';
import store from '@/state/store'

import VueCookies from 'vue-cookies-reactive'

import App from './App.vue'

import { initFirebaseBackend, refreshToken } from './authUtils'
import i18n from './i18n'
import VueSocialChat from 'vue-social-chat'

import ClassicEditor from "@ckeditor/ckeditor5-build-classic";


const options = {
  toast: {
    position: SnotifyPosition.centerTop,
    showProgressBar: false,
    transition: 'fade',
    icon: false,
    timeout: 2000,
    closeOnClick: true,
    pauseOnHover: true,
    maxOnScreen: 1,
    maxAtPosition: 1,
    preventDuplicates: true,
    titleMaxLength: 110,
    bodyMaxLength: 1110,
    backdrop: 0.5,
    backdropBorderRadius: '10px',
    bodyStyle: {
      backgroundColor: '#333',
      color: '#fff',
      borderRadius: '8px',
      padding: '10px',
      boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
      border: '1px solid #555',
      zIndex: 1000,
    },
    titleStyle: {
      fontWeight: 'bold',
      fontSize: '18px',
      marginBottom: '5px',
      zIndex: 1000,
    },
   
    
  }
};


Vue.component("v-select", vSelect);


Vue.use(VueCookies)
Vue.$cookies.config('0','/','',true, 'Lax')
Vue.use(VueSocialChat)


initFirebaseBackend();

Vue.use(VueRouter)
Vue.use(vco)

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(VueMask)

Vue.use(VueSweetalert2);
Vue.use(VueAxios, axios)
Vue.use(Snotify, options)



// const nprogress = new NProgress({ parent: '.nprogress-container' })
const nprogress = new NProgress()

const options2 = {
  latencyThreshold: 100, 
  router: false, 
  http: true 
};
Vue.use(NProgress, options2)


// AXIOS REQUESTS INTERCEPTOR
axios.interceptors.request.use((config) => {
  
    //getting token from cookie
    const token = Vue.$cookies.get('tok');

    if (token != null) {
      config.headers.common['Authorization'] = "Bearer " + token;
    }    
    
    if (!config.url.startsWith("/api/notifications") && !config.url.startsWith("/api/auth/refresh")) {
      nprogress.set(0.6)
    }
    
    return config;
}, (error) => {
    nprogress.done();
    return Promise.reject(error);
});

// AXIOS RESPONSES INTERCEPTOR
axios.interceptors.response.use((response) => {
  nprogress.done();
  return response;
}, (error) => {

  nprogress.done();

    if (error == null || error.response == null) {
    return; 
  }

  if (error.response.status == 401) {
    return refreshToken(store).then( () => {

      const token = Vue.$cookies.get('tok');
      error.config.headers['Authorization'] = 'Bearer ' + token;
      error.config.baseURL = undefined;
      return axios.request(error.config);
    }, () => {

      if(!error.response.config.url.startsWith("/api/notifications") /*&& !error.response.config.url == "/"*/) {

        console.log('failed to refresh token')

        //Swal.fire("Session expirée !", "Vous serez redirigé vers la page de Login.", "warning")
        //.then(() => {

          var currentDomain = window.location.hostname;
          var cookieDomain = currentDomain.startsWith('www.') ? currentDomain.substring(4) : currentDomain;
          

          //delete cookies if refresh fails
          document.cookie = 'tok' + '=; Max-Age=0; domain=' + cookieDomain + '; path=/';
          document.cookie = 'rtok' + '=; Max-Age=0; domain=' + cookieDomain + '; path=/';

          location.reload();

          /*router.push({
            path:'/logout',
          });*/

        //});
        return;
    }

    });
  }
  
  if (error.response.status == 409) {
    /*console.log('Une autre session a été ouverte avec le même utilisateur');*/
      var currentDomain = window.location.hostname;
      var cookieDomain = currentDomain.startsWith('www.') ? currentDomain.substring(4) : currentDomain;

       //delete cookies if refresh fails
       document.cookie = 'tok' + '=; Max-Age=0; domain=' + cookieDomain + '; path=/';
       document.cookie = 'rtok' + '=; Max-Age=0; domain=' + cookieDomain + '; path=/';

       location.reload();
    return;    
  }


  if (error.response.status == 500) {
    console.log('500: Une erreur interne du serveur est survenue')
    return
  }

  if (error.response.status == 404) {
    console.log('Ressource introuvable!')
    return
  }

  if (error.response.status == 403) {
    console.log('403: Vous n\'avez pas le droit d\'accéder à la ressource demandée.')
    return
  }

  if (error.response.status == 401) {
    console.log('401: Vous n\'avez pas le droit d\'accéder à la ressource demandée.')
    return
  }

  if (error.response && error.response.data && error.response.status == 400) {
    return Promise.reject(error.response.data);
  } else {
    console.log(error)
    return /* Promise.reject('Une erreur interne du serveur est survenue')*/
  }
  
});

ClassicEditor.defaultConfig = {
  toolbar: {
    items: [
      'heading',
      '|',
      'bold',
      'italic',
      '|',
      'bulletedList',
      'numberedList',
      '|',
      'insertTable',
      '|',
      'undo',
      'redo'
    ]
  },
  image: {
    toolbar: [
      'imageStyle:full',
      'imageStyle:side',
      '|',
      'imageTextAlternative'
    ]
  },
  table: {
    contentToolbar: [ 'tableColumn', 'tableRow', 'mergeTableCells' ]
  },
  language: 'fr'
}


new Vue({
  router,
  store,

  mounted() {
    // Dispatch the action when the root component is mounted
    this.$store.dispatch('fetchMainSectionId');
    this.$store.dispatch('fetchMenuItems');
    this.$store.dispatch('fetchCart');
    this.$store.dispatch('fetchComparatorItems');
    this.$store.dispatch('fetchGiftCode');
  },

  i18n,
  render: h => h(App)
}).$mount('#app')
